import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import { ACCESSORIES } from "tagTypes";

export const useAccessoriesQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/accessories",
    query,
    tags: [ACCESSORIES],
  });

export const useLazyAccessoriesQuery = () => {
  const [accessories, data] = useLazyGetQuery();
  const accessorie = async (query = {}) =>
    await accessories(
      {
        endpoint: "/accessories",
        query,
        tags: [ACCESSORIES],
      },
      true
    ).unwrap();
  return [accessorie, data];
};

export const usePostAccessoriesMutation = () => {
  const [accessories, data] = usePostMutation();
  const accessorie = async (payload, query = {}) =>
    await accessories({
      endpoint: "/accessories",
      query,
      payload: payload || {},
      toastMessage: "Accessories added successfully",
      tags: [ACCESSORIES],
    }).unwrap();
  return [accessorie, data];
};
